import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import DeleteButton from '../../v2/buttons/DeleteButton';
import ConfirmModal from '../../ui/modals/ConfirmModal';

export function DocumentDeleteButton({
  isOrder,
  document,
  onConfirm,
  onDecline,
}) {
  const { t } = useTranslation();
  const entity = isOrder ? 'order' : 'shipment';

  const [showConfirmation, setShowConfirmation] = useState(false);
  const handleConfirm = () => {
    onConfirm?.(document);
    setShowConfirmation(false);
  };
  const handleDecline = () => {
    onDecline?.(document);
    setShowConfirmation(false);
  };

  return (<>
    <DeleteButton
      dataTestId="DeleteButton-bcde1f82"
      size="small"
      onClick={() => setShowConfirmation(true)} />
    <ConfirmModal
      dataTestId="ConfirmModal-a6004b20"
      show={showConfirmation}
      title={t('CONFIRM_DOCUMENT_DELETE')}
      message={t('CONFIRM_DOC_DELETION_MESSAGE', {
        doc_name: document.name,
        entity,
      })}
      onConfirm={handleConfirm}
      onHide={handleDecline} />
  </>);
}
